module.exports = __webpack_public_path__ + "static/media/02.-2-3.c767ae28.jpg";